export default "__VITE_ASSET__BWZIxIOE__"